import { render, staticRenderFns } from "./VTemplateReport.vue?vue&type=template&id=45a17ddd&lang=pug"
import script from "./VTemplateReport.vue?vue&type=script&lang=ts"
export * from "./VTemplateReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports